// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__30906","title":"AfterFrontImage_title__2Cx90"};